/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedAffirm_viewer$ref: FragmentReference;
export type PdpSharedAffirm_viewer = {|
  +affirmEnabled: ?boolean,
  +regionalInfo: ?$ReadOnlyArray<?{|
    +countryCode: ?string
  |}>,
  +$refType: PdpSharedAffirm_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedAffirm_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "affirmEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "AFFIRM",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"AFFIRM\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "regionalInfo",
      "storageKey": null,
      "args": null,
      "concreteType": "RegionalInfo",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "countryCode",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cc85f0e424435e768f5ccfa21cc6727c';
module.exports = node;
